import { TurfServiceService } from 'src/app/providers/services/turf-service/turf-service.service';
import { UserManagerService } from './services/userManager/user-manager.service';
import { Injectable } from '@angular/core';
import * as Stomp from 'stompjs';
import { SportServiceService } from './services/sport-service/sport-service.service';
import { ConfigService } from './config/config.service';
import { Subject } from 'rxjs';
@Injectable()
export class WebsocketService {

  stompClient: any;
  getCagnote: Subject<[]> = new Subject();
  checkIdletime = false;
  constructor(

    private configs: ConfigService,
    private userServices: UserManagerService,
    private sportService: SportServiceService,
    private turfService: TurfServiceService) {
    this.userServices.onLogIn.subscribe(data => {
      if (data) {

        // this.connect_session();

      } else {
        this.disconnect();
      }

    });
  }



  private connectRabbit(client, user, passwd, fxn) {
    this.checkIdletime = false;
    let me = this;
    if (!client.connected) {
      client.connect(user, passwd, (frame) => {
        fxn(client, this);
      }, (message) => {

        setTimeout(() => { me.connectRabbit(client, user, passwd, fxn); }, 5000);
      }, '/');
    }
  }

  public subscribe(client, me) {
    if (client.connected) {
      let param = { exchange: "flexbet_dashboard", routine: "*.*.two_race" }
      me.sendGlobal(client, param)
    }
  }
  public connectRaces() {
    this.connect(this.configs.PROXIES.Rabbit_Address, this.configs.RABBIT_CONFIG.USER, this.configs.RABBIT_CONFIG.PASSWD, this.subscribe);

  }
  public connect_session() {

    this.connect(this.configs.PROXIES.Rabbit_Address_user_session, this.configs.RABBIT_CONFIG.ACCUSER, this.configs.RABBIT_CONFIG.ACCPASSWD, this.subscribeToSessionExchange, true);

  }
  public connect(address, user, passwd, fxn, isAccountStomp?) {
    let ws = new WebSocket(address);
    let stompclient = Stomp.over(ws);

    this.connectRabbit(stompclient, user, passwd, fxn);

    stompclient.debug = null;
    if (isAccountStomp)
      this.stompClient = stompclient;
  }
  subscribeToSessionExchange(client, me) {
    if (me.userServices.userData && me.userServices.userData.account_code) {

      let param = { exchange: me.configs.RABBIT_CONFIG.EXCHANGE, routine: me.configs.RABBIT_CONFIG.QUEUE + '.' + me.userServices.userData.account_code }
      me.sendGlobal(client, param)

    }

  }

  public disconnect() {
    if (this.stompClient) {
      this.stompClient.disconnect();
    }
  }

  sendGlobal(client, message) {
    let me = this;
    if (client) {
      client.subscribe(`/exchange/${message.exchange}/${message.routine}`, (m) => {
        const reversedText = m.body.split('').join('');
        me.processMessage(reversedText);
      });
    } else {
      setTimeout(() => {
        me.sendGlobal(client, message);
      }, 1000);
    }

  }

  async processMessage(rawMsg) {
    this.configs.lastmessagetime = new Date();


    let message = JSON.parse(rawMsg);
    // console.log(message);

    if (message.hasOwnProperty('message')) {
      this.turfService.load = true;
      this.turfService.cagnoteGames = [];

      for (const item of message.message) {
        const cagnote = { reunioun: '', game: '', amount: '' };
        cagnote.reunioun = item.toString().split('-')[0];
        cagnote.amount = item.toString().split(':')[2];
        const start = item[0].substring(item[0].indexOf('[') + 1, item[0].indexOf(']'));

        cagnote.game = this.configs.games[start.trim().toUpperCase()].trim();

        this.turfService.cagnoteGames.push(cagnote);
      }
      // this.getCagnote.next(this.cagnoteGames)
    }

    if (message.hasOwnProperty('tcourse')) {
      this.turfService.courseChange$.next(message.tcourse);
      this.turfService.message = message.tcourse;
      // message = message.tcourse;
    }

    if (typeof (message) == 'string')
      message = JSON.parse(message);
    if (message.hasOwnProperty('data') && message.data.hasOwnProperty('isExpired') && message.data.isExpired) {
      if (this.userServices.userData.session == message.data.session) {
        if (message.data.isForced) {
          // console.log('force logout');
          this.userServices.logout({ sessionToken: this.userServices.userData.session });
          this.disconnect();
        } else {
          if (this.userServices.userIdleTime < this.userServices.expireTime) {

            this.userServices.renewSession();

          } else {
            this.userServices.userData = undefined;
            this.disconnect();
          }

        }
      } else {
        this.userServices.logout({ sessionToken: this.userServices.userData.session });
        this.disconnect();
      }



    }
    if (message.hasOwnProperty('data') && message.type == 'balance') {
      this.userServices.userData.balances = message.data.balances;
    }
  }
}
